export enum TabTypes {
  Comments = 'comments',
  Timeline = 'timeline',
}
